import LanguageStatusSelect from "./language-status-select";


const LanguageFormFields = {
    StatusSelect: LanguageStatusSelect,
};

export default LanguageFormFields;
